import { useCore } from '@/composables/core'

/*
 * trigger from JS console:
 * document.dispatchEvent(new CustomEvent('BooksyWebViewMessage', { detail: { name: "referral.code", data: { referral_code: "123" } }}))
 */

type StoreState = {
  identity?: { accessToken?: unknown }
  app?: { basePath?: string; language?: string; country?: string }
}

const name = 'referral.code'

const callback = ({ referral_code }: { referral_code?: string }) => {
  const { store } = useCore()
  const state = store.state as StoreState

  if (state.identity?.accessToken) return

  const url = window.location.origin
    + (state.app?.basePath ?? '')
    + `/${state.app?.language ?? ''}-${state.app?.country ?? ''}/onboarding`
    + `?referral=${referral_code}`
  // Assign string to trigger redirect; cast for TypeScript (Location type doesn't allow string assign)
  ;(window as Window & { location: string | Location }).location = url
}

export default { name, callback }
